import React from 'react'

const CoreValues = () => {
    return (
        <>

        </>
    )
}

export default CoreValues
